/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function InlinePauseSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_598_9207)">
        <path
          d="M12.7417 0.751953H1.2417C0.965137 0.751953 0.741699 0.975391 0.741699 1.25195V12.752C0.741699 13.0285 0.965137 13.252 1.2417 13.252H12.7417C13.0183 13.252 13.2417 13.0285 13.2417 12.752V1.25195C13.2417 0.975391 13.0183 0.751953 12.7417 0.751953ZM12.1167 12.127H1.8667V1.87695H12.1167V12.127Z"
          fill="currentColor"
        />
        <path
          d="M5.35257 4H4.1859C4.07896 4 3.99146 4.0675 3.99146 4.15V9.85C3.99146 9.9325 4.07896 10 4.1859 10H5.35257C5.45951 10 5.54701 9.9325 5.54701 9.85V4.15C5.54701 4.0675 5.45951 4 5.35257 4ZM9.79701 4H8.63034C8.5234 4 8.4359 4.0675 8.4359 4.15V9.85C8.4359 9.9325 8.5234 10 8.63034 10H9.79701C9.90396 10 9.99146 9.9325 9.99146 9.85V4.15C9.99146 4.0675 9.90396 4 9.79701 4Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_598_9207">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(-0.00854492)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function InlinePauseIcon(props: {
  style?: React.CSSProperties;
  className?: string;
}) {
  return <Icon component={InlinePauseSvg} {...props} />;
}
